import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import {
  getSummerSchoolSparkById,
  getSummerSchoolSpark,
  removeSummerSchoolSpark,
  updateSummerSchoolSparkStatus,
} from "../repositories/summerSchoolSparkRepository";

export const summerSchoolSparkService = {
  getSummerSchoolSpark: async ({ currentPage, pageSize }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    return await getSummerSchoolSpark({
      page: Number(pageNumber) - 1,
      size: itemsPerPage,
    });
  },

  getSummerSchoolSparkById: async (id) => await getSummerSchoolSparkById(id),

  updateSummerSchoolSparkStatus: async (status, body) =>
    await updateSummerSchoolSparkStatus(status, body),

  removeSummerSchoolSpark: async (id) => await removeSummerSchoolSpark(id),
};
